import { useEffect } from 'react';

export default function OrganizationSchema() {
  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'application/ld+json';

    const structuredData = {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: 'Haclab Company Limited',
      url: 'https://haclab.net',
      logo: 'https://haclab.net/assets/images/logo.png',
      description:
        'Haclab Company Limited is a custom software development company based in Kampala, Uganda, providing modern IT solutions including web development, mobile app development, and more.',
      foundingDate: '2020',
      founders: [
        {
          '@type': 'Person',
          name: 'Derick Mudali',
        },
      ],
      address: {
        '@type': 'PostalAddress',
        streetAddress: 'Kireka Kamuli Road',
        addressLocality: 'Kampala',
        addressRegion: 'Central Region',
        addressCountry: 'Uganda',
        postalCode: '256',
      },
      contactPoint: {
        '@type': 'ContactPoint',
        telephone: '+256 708 183 272',
        contactType: 'customer service',
        email: 'info@haclab.net',
        areaServed: [
          'Uganda',
          'East Africa',
          'Kampala',
          'Entebbe',
          'Jinja',
          'Mukono',
          'Wakiso',
          'Mbarara',
          'Gulu',
        ],
        availableLanguage: ['English'],
      },
      sameAs: [
        'https://github.com/haclab-co',
        'https://twitter.com/HaclabCo',
        'https://web.facebook.com/HytechUg',
        'https://www.instagram.com/haclab_co/',
        'https://www.linkedin.com/company/hytech-Uganda',
        'https://clutch.co/ug/seo-firms',
        'https://techbehemoths.com/companies/on-site-optimization/uganda',
        'https://www.yellowpages-uganda.com/listings/uganda/central-region/kampala/computers-internet-i-t-uganda/haclab-company-limited/',
        'https://lendsqr.com/providers/haclab%20company%20limited'
      ],
      knowsLanguage: ['English', 'Luganda', 'Swahili'],
      areaServed: {
        '@type': 'GeoCircle',
        geoMidpoint: {
          '@type': 'GeoCoordinates',
          latitude: '0.3476',
          longitude: '32.6339',
        },
        geoRadius: '500 km',
      },
      keywords:
        'software development, web development, mobile app development, custom software, IT solutions, Uganda, Kampala, Entebbe, Jinja, Mukono, Wakiso',
    };

    script.innerHTML = JSON.stringify(structuredData);
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return null;
}
